export default __webpack_public_path__ + "static/media/high.d8622b72.svg";